import { FilesMutationTypes } from './types';

export const mutations = {
    [FilesMutationTypes.SetFiles](state, {file}) {
        return state.files = file
    },
}